<style>
    ol, ul{
        margin-left: 1.25rem !important;
    }
    ol {
        list-style-type: decimal !important;
    }
    ul {
        list-style-type: disc !important;
    }
</style>

<template>
    <div v-if="courseDetail !== null" class="grid w-full grid-cols-11 bg-white">
        <div class="col-span-11">
            <div class="h-full md:h-[5.5rem] bg-white border-b-2 w-full items-center grid grid-cols-12">
                <div class="flex items-center justify-start h-full col-span-10 gap-5 py-3 pl-6">
                    <img @click="$router.push('/Internal/Core')" src="@/assets/img/logo.png"
                        class="h-[3.5rem] hidden md:inline cursor-pointer" alt="">
                    <img @click="$router.push('/Internal/Core')" src="@/assets/img/sm-logo.png"
                        class="h-[2rem] md:hidden cursor-pointer" alt="">
                    <a-divider type="vertical" class="h-full bg-gray-200 w-[2px]"></a-divider>
                    <span @click="goTo('/Course/Detail/' + courseDetail.id)"
                        class="hidden text-base font-semibold text-gray-800 cursor-pointer lg:inline lg:text-lg hover:text-primary">{{
                            courseDetail.title
                        }}</span>
                    <span @click="goTo('/Course/Detail/' + courseDetail.id)"
                        class="inline text-base font-semibold text-gray-800 cursor-pointer lg:hidden lg:text-lg hover:text-primary">{{
                            courseDetail.title.slice(0, 32)
                        }}...</span>
                </div>
                <div
                    class="flex items-center justify-end h-full col-span-2 gap-5 px-0 py-3 lg:col-span-2 lg:col-start-11 pe-6 md:px-8">
                    <div class="flex flex-row items-center justify-end gap-3">
                        <a-progress :size="40" type="circle" :percent="parseFloat(learningProgress.percentage.toFixed(1))" strokeColor="#0a543f"
                            trailColor="#3e8b174D" class="m-0" />
                        <div class="flex-col hidden gap-1 md:flex">
                            <span class="text-xs font-medium">Your progress:</span>
                            <span class="text-xs text-gray-600">{{ learningProgress.total_my_progress }} of {{ learningProgress.total_sub_section }} completed</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="flex flex-col h-[90vh] col-span-11 lg:col-span-7 xl:col-span-8 overflow-y-auto scrollbar-visible">
            <div v-if="panel === 'Video'" class="relative h-[60vh] flex justify-center items-center bg-white w-full">

                <!-- 1. Video Section Player LAYER -->
                <!-- Tetap render di background agar frame terakhir video tetap terlihat di balik overlay jika mau -->
                <div class="flex items-center justify-center w-full h-full">
                    <div id="player" 
                        class="w-full h-[50vh] md:h-[60vh]"
                        width="100%" 
                        height="100%"
                    >
                    </div>
                </div>

                <a-modal 
                    :open="shouldShowHelper" 
                    @cancel="handleCloseHelper"
                    :footer="null" 
                    :closable="true"
                    centered
                    bodyStyle="padding: 0px; overflow: hidden; border-radius: 12px;"
                >
                    <!-- Isi konten helper bawaan kamu di dalam modal -->
                    <div class="flex flex-col items-center justify-center w-full p-6 text-center bg-gray-50 md:p-8 rounded-xl">
                        <div class="flex flex-col items-center max-w-md gap-4 md:gap-5">
                            <!-- Icon -->
                            <div class="p-3.5 bg-primary bg-opacity-10 text-primary rounded-full mb-1">
                                <IconSparkles :size="32" class="text-primary" />
                            </div>
                            
                            <!-- Title & Description -->
                            <div class="flex flex-col gap-2">
                                <h3 class="text-lg font-bold text-gray-800 md:text-xl">Materi Pembelajaran</h3>
                                <p v-if="currentSubSectionContent?.helper_link && !currentSubSectionContent?.downloadable_link" class="max-w-xs text-xs leading-relaxed text-gray-500 md:text-sm md:max-w-md">
                                   Ada pertanyaan? Silakan kirim pertanyaan Anda melalui tombol Kirim Pertanyaan.
                                </p>
                                <p v-else-if="currentSubSectionContent?.downloadable_link && !currentSubSectionContent?.helper_link" class="max-w-xs text-xs leading-relaxed text-gray-500 md:text-sm md:max-w-md">
                                   Ingin mengunduh materi? Silakan klik tombol Download Materi.
                                </p>
                                <div v-else-if="currentSubSectionContent?.helper_link && currentSubSectionContent?.downloadable_link" class="max-w-xs text-xs leading-relaxed text-gray-500 md:text-sm md:max-w-md">
                                    <p>Ada pertanyaan? Silakan kirim pertanyaan Anda melalui tombol Kirim Pertanyaan.</p>
                                    <p>Ingin mengunduh materi? Silakan klik tombol Download Materi.</p>
                                </div>
                            </div>

                            <!-- Action Buttons -->
                            <div class="flex flex-col items-center justify-center w-full gap-3 mt-2 sm:flex-row">
                                <a v-if="currentSubSectionContent?.helper_link" :href="currentSubSectionContent?.helper_link" target="_blank" class="w-full sm:w-auto">
                                    <a-button type="primary" size="large" class="flex items-center justify-center w-full gap-2 px-6">
                                        <span>Kirim Pertanyaan</span>
                                        <IconArrowRight :size="16" />
                                    </a-button>
                                </a>
                                <a v-if="currentSubSectionContent?.downloadable_link" :href="currentSubSectionContent?.downloadable_link" target="_blank" class="w-full sm:w-auto">
                                    <a-button type="primary" size="large" class="flex items-center justify-center w-full gap-2 px-6">
                                        <span>Download Materi</span>
                                        <IconDownload :size="16" />
                                    </a-button>
                                </a>
                            </div>
                        </div>
                    </div>
                </a-modal>

                <div class="absolute inset-0 flex flex-col items-center justify-center w-full h-full" :class="{ 'hidden': isHiddenEmptyVideo }">
                    <a-empty>
                        <template #description>
                            <h1 class="text-xl font-semibold tracking-wide text-primary md:text-3xl">
                                Sorry, this course is still in progress
                            </h1>

                            <p class="text-lg leading-loose tracking-wide md:leading-loose text-light">
                                Please check back later when the content is available.
                            </p>
                        </template>
                    </a-empty>
                </div>
                <!-- <iframe 
                    width="100%" 
                    height="100%" 
                    :src="videoUrl" 
                    frameborder="0" 
                    allow="autoplay; encrypted-media" 
                    allowfullscreen
                    ref="videoIframe" 
                    class="h-[50vh] md:h-[60vh]">
                </iframe> -->

                <!-- <a-progress :percent="progressBarWidth" :show-info="false" stroke-color="#0a543f" strokeLinecap="butt"
                    trail-color="#ffffff37" class="absolute w-full bottom-8" />
                <div
                    class="absolute bottom-0 h-[3rem] left-0 w-full p-4 bg-[#000000] bg-opacity-30 flex items-center justify-between">
                    <div class="flex flex-row items-center gap-4">
                        <button @click="togglePlayPause" class="text-white">
                            <IconPlayerPlayFilled :size="20" v-if="!isPlaying" />
                            <IconPlayerPauseFilled :size="20" v-else />
                        </button>
                        <div class="flex items-center gap-4">
                            <span class="text-sm text-white">{{ formatTime(currentTime) }} / {{ formatTime(duration)
                            }}</span>
                        </div>
                    </div>
                    <div class="flex flex-row items-center gap-4">
                        <button @click="toggleMute" class="text-lg text-white">
                            <IconVolume2 :size="20" v-if="!isMuted" />
                            <IconVolumeOff :size="20" v-else />
                        </button>
                        <button @click="toggleFullscreen" class="text-lg text-white">
                            <IconMaximize :size="20" v-if="!isFullscreen" />
                            <IconMinimize :size="20" v-else />
                        </button>
                    </div>
                </div> -->
            </div>
            
            <quiz v-if="panel !== 'Video'" :quiz="quiz" :type="panel" :panelStatusCompleted="panelStatusCompleted"
                v-model:isQuizPassed="isQuizPassed" @answerSubmitted="handleAnswerSubmitted" :key="quiz" 
            />
            
            <div class="w-full px-4 py-3 md:px-6 xl:px-10 lg:py-6">
                <div class="flex justify-between w-full">
                    <a-button class="flex flex-row items-center justify-center gap-2 mb-2 cursor-pointer float-end" @click="goTo('/Internal/' + (courseDetail?.program_id ? ('Program/Detail/' + courseDetail?.program?.slug + '?tab=1&activeKey='+courseDetail?.category_id) : 'Course'))">
                        <IconListDetails :size="18" />
                        Back to {{ courseDetail?.program_id ? 'Program Course' : 'My Course' }}
                    </a-button>

                    <div v-if="isEnded" class="flex flex-row items-center gap-2">
                        <!-- Show Learning Resource button: visible during replay when helper_link exists -->
                        <a-button
                            v-if="(!!currentSubSectionContent?.helper_link || !!currentSubSectionContent?.downloadable_link) && replayingVideo && panel == 'Video'"
                            class="flex flex-row items-center justify-center gap-2 mb-2 cursor-pointer"
                            @click="showResourceDuringReplay"
                        >
                            <IconSparkles :size="18" />
                            Show Learning Resource
                        </a-button>

                        <a-button class="flex flex-row items-center justify-center gap-2 mb-2 cursor-pointer float-end" type="primary" @click="nextSectionCourse(nextCourse.index, nextCourse.lIndex)" v-if="isQuizPassed || isAbleToNext(panelStatusCompleted) || panel == 'Video'">
                            {{ isNextAvailable(nextCourse.index, nextCourse.lIndex) ? 'Next' : 'Completed' }}
                            <IconArrowRight :size="18" v-if="isNextAvailable(nextCourse.index, nextCourse.lIndex)" />
                            <IconCircleCheckFilled :size="18" v-else />
                        </a-button>
    
                        <a-button class="flex flex-row items-center justify-center gap-2 mb-2 cursor-pointer float-end" type="primary" @click="onClickLecture(nowCourse.index, nowCourse.lIndex)" v-else-if="!isQuizPassed && panel == 'Quiz'">
                            Try Again
                            <IconReload :size="18" />
                        </a-button>
                    </div>
                </div>

                <a-tabs v-model:activeKey="tab" class="w-full">
                    <a-tab-pane :key="5" v-if="!lgAndUp()" tab="Course Content" >
                        <a-collapse v-model:activeKey="sectionKey" expandIconPosition="end"
                            style="border-bottom: 2px solid #e6e7eb; border-radius: 0;" ghost
                            v-for="(cItem, index) in progressContent" :key="index" v-if="progressContent?.length > 0">
                            <a-collapse-panel :key="index">
                                <div class="flex flex-col w-full">
                                    <div v-for="(lItem, lIndex) in cItem.sub_section"
                                        :key="lIndex" :class="[
                                            'w-full flex flex-row cursor-pointer py-3 px-4 items-center justify-between',
                                            {
                                                'bg-[#3e8b174D]': isActiveLecture(index, lIndex),
                                                'hover:bg-[#3e8b171A]': !isActiveLecture(index, lIndex)
                                            }
                                        ]">
                                        <div class="flex flex-row items-center justify-between w-full gap-4" @click="isPrevCompleted(index, lIndex) || isAbleToNext(lItem.completed) || (index == 0 && lIndex == 0) ? onClickLecture(index, lIndex) : '' ">
                                            <!-- <a-checkbox></a-checkbox> -->
                                            <div class="flex flex-col gap-2">
                                                <span class="text-sm">{{ lIndex + 1 }}. {{ lItem.title
                                                }}</span>
                                                <div
                                                    :class="['flex flex-row gap-1 items-center', lIndex === 0 && index === 0 ? 'text-black' : 'text-gray-600']">
                                                    <IconDeviceTv v-if="lItem.type === 'Video'" :size="18"
                                                        stroke-width="1.5" />
                                                    <IconFile v-else :size="18" stroke-width="1.5" />

                                                    <span class="text-xs">{{  lItem.type == 'Video' ? lItem.duration+'min' : lItem.type }}</span>
                                                </div>
                                            </div>
                                            
                                            <IconCircleCheckFilled class="text-primary" v-if="lItem.completed == 1 || (isEnded && nowCourse.lIndex == lIndex && nowCourse.index == index && lItem.type == 'Video')" />
                                            <IconReport class="text-yellow-600" v-else-if="lItem.completed == 2 || (isEnded && nowCourse.lIndex == lIndex && nowCourse.index == index && isQuizPassed)" />
                                            <IconCircleXFilled class="text-red-700" v-else-if="lItem.completed == 3" />
                                        </div>
                                    </div>

                                </div>
                                <template #header>
                                    <div class="flex flex-col gap-1">
                                        <span class="text-base font-semibold">{{ cItem.title
                                        }}</span>
                                        <span class="text-xs text-gray-600">{{ cItem.progress }} / {{ cItem?.sub_section?.length }}</span>
                                    </div>
                                </template>
                            </a-collapse-panel>
                            <template #expandIcon="{ isActive }">
                                <IconChevronLeft :size="15" stroke-width="2.5" v-if="isActive" />
                                <IconChevronDown :size="15" stroke-width="2.5" v-else />
                            </template>
                        </a-collapse>

                        <div class="w-full" v-else>
                            <a-empty :image="Empty.PRESENTED_IMAGE_SIMPLE" class="mt-20" :class="{ 'hidden': isHiddenEmptyCourseContent }">
                                <template #description>
                                    <span class="text-sm text-gray-500">
                                        Course content is empty
                                    </span>
                                </template>
                            </a-empty>
                        </div>
                    </a-tab-pane>
                    <a-tab-pane :key="0" tab="Overview">
                        <div class="flex flex-col w-full gap-5">
                            <span class="text-sm font-semibold text-gray-800 lg:text-3xl">{{ courseDetail.title
                            }}</span>
                            <div class="flex flex-col gap-2">
                                <span class="text-sm font-semibold text-light">Description</span>
                                <span class="text-sm font-light leading-loose" >
                                    <span v-html="sanitizedDesc(courseDetail.desc)"></span>
                                    <!-- {{ sanitizedDesc(courseDetail.desc).slice(0, isExpanded ? undefined : 150) + (isExpanded ? '' : '...') }} -->

                                    <!-- <span
                                        class="font-medium cursor-pointer text-primary"
                                        @click="toggleReadMore"
                                    >
                                        {{ isExpanded ? 'Read Less' : 'Read More' }}
                                    </span> -->
                                </span>
                            </div>
                            <span class="text-sm font-semibold text-light">Course Detail</span>
                            <div class="grid w-full grid-cols-2 gap-4 md:grid-cols-3 xl:grid-cols-5">
                                <div class="flex flex-col w-full gap-2 p-4 bg-white border">
                                    <span class="text-xs text-gray-500">Lesson</span>
                                    <div class="flex flex-row items-center gap-2">
                                        <IconColorSwatch class="text-primary" :size="24" />
                                        <span class="text-base font-medium text-light">{{ courseInfo.total_lessons }}</span>
                                    </div>
                                </div>
                                <div class="flex flex-col w-full gap-2 p-4 bg-white border">
                                    <span class="text-xs text-gray-500">Duration</span>
                                    <div class="flex flex-row items-center gap-2">
                                        <IconClockPlay class="text-primary" :size="24" />
                                        <span class="text-base font-medium text-light">{{ minuteToHour(courseInfo.total_duration) }}</span>
                                    </div>
                                </div>
                                <div class="flex flex-col w-full gap-2 p-4 bg-white border">
                                    <span class="text-xs text-gray-500">Video</span>
                                    <div class="flex flex-row items-center gap-2">
                                        <IconBrandYoutube class="text-primary" :size="24" />
                                        <span class="text-base font-medium text-light">{{ courseInfo.total_video }}</span>
                                    </div>
                                </div>
                                <div class="flex flex-col w-full gap-2 p-4 bg-white border">
                                    <span class="text-xs text-gray-500">Asssignment</span>
                                    <div class="flex flex-row items-center gap-2">
                                        <IconClipboardText class="text-primary" :size="24" />
                                        <span class="text-base font-medium text-light">{{ courseInfo.total_assignment }}</span>
                                    </div>
                                </div>
                                <div class="flex flex-col w-full gap-2 p-4 bg-white border">
                                    <span class="text-xs text-gray-500">Level</span>
                                    <div class="flex flex-row items-center gap-2">
                                        <IconChartBar class="text-primary" :size="24" />
                                        <span class="text-base font-medium text-light">{{ courseInfo.level }}</span>
                                    </div>
                                </div>
                            </div>
                            <!-- <div class="flex flex-row items-center gap-2 text-gray-700">
                                <IconCalendarStats size="18" stroke-width="1" />
                                <span class="text-xs">Last updated 08/2024</span>
                            </div> -->
                        </div>
                    </a-tab-pane>
                    <a-tab-pane :key="1" :tab="`Reviews (${reviews?.length + (myReview ? 1 : 0)})`">
                        <div class="flex flex-col w-full gap-3">

                            <div class="w-full border">
                                <div v-if="myReview" class="flex flex-col gap-4 p-4 pt-4 pb-6">
                                    <div class="flex flex-row items-center gap-4">
                                        <img :src="myReview?.startup?.photo || avatarUrl(myReview.startup.name)" class="w-8 h-8 rounded-full" alt="Avatar">
                                        <div class="flex flex-col">
                                            <span class="text-sm font-semibold">{{ myReview.startup.name }}</span>
                                            <div class="flex flex-row items-center gap-3">
                                                <!-- <a-rate class="text-sm" disabled allowHalf :value="myReview.star" /> -->
                                                <rater-element :rating="parseFloat(myReview.star)" />
                                                <span class="text-xs font-medium">{{ moment(myReview.created_at).fromNow() }}</span>
                                            </div>
                                        </div>
                                    </div>
                                    <span class="text-sm font-light leading-relaxed">
                                        {{ myReview.review }}
                                    </span>
                                </div>

                                <div class="p-2" v-else>
                                    <div class="flex flex-row items-center gap-3 ml-2">
                                        <label>Rate <span class="text-red-500">*</span></label>
                                        <!-- <a-rate class="self-start ml-2 text-xl" v-model:value="formReview.star" /> -->
                                        <rater-input v-model="formReview.star" />
                                    </div>
    
                                    <a-divider class="my-2"></a-divider>
    
                                    <a-textarea class="resize-none" 
                                        :bordered="false" 
                                        :rows="4" 
                                        v-model:value="formReview.review"
                                        placeholder="Add New Review" 
                                        :maxlength="255"
                                        show-count
                                    >
                                        
                                    </a-textarea>
    
                                    <a-divider class="my-2"></a-divider>
                                    
                                    <div class="flex flex-col items-end">
                                        <a-button class="w-fit" type="primary" @click="addReview">Submit</a-button>
                                    </div>
                                </div>
                            </div>

                            <div v-for="item in reviews" :key="item" class="flex flex-col w-full gap-4 pt-4 pb-6 border-b">
                                <div class="flex flex-row items-center gap-4">
                                    <img :src="item?.startup?.photo || avatarUrl(item.startup.name)" class="w-8 h-8 rounded-full" alt="Avatar">
                                    <div class="flex flex-col">
                                        <span class="text-sm font-semibold">{{ item.startup.name }}</span>
                                        <div class="flex flex-row items-center gap-3">
                                            <!-- <a-rate class="text-sm" disabled allowHalf :value="item.star" /> -->
                                            <rater-element :rating="parseFloat(item.star)" />
                                            <span class="text-xs font-medium">{{ moment(item.created_at).fromNow() }}</span>
                                        </div>
                                    </div>
                                </div>
                                <span class="text-sm font-light leading-relaxed">
                                    {{ item.review }}
                                </span>
                            </div>
                        </div>
                    </a-tab-pane>
                    <a-tab-pane :key="2" :tab="`Q & A (${qnas?.length ?? 0})`">
                        <div class="flex flex-col w-full gap-3">
                            <div class="flex flex-col items-end w-full p-2 border">
                                <a-textarea class="resize-none" :bordered="false" :rows="4"
                                    placeholder="Ask New Question" v-model:value="formQnas.content"></a-textarea>
                                <a-divider class="my-2"></a-divider>
                                <a-button class="w-fit" type="primary" @click="addQnas">Submit</a-button>
                            </div>
                            <a-collapse v-model:activeKey="openQna" ghost>
                                <a-collapse-panel :showArrow="false" v-for="(qItem) in qnas" :key="qItem.id">
                                    <div class="flex flex-col w-full px-16 py-2" v-for="reply in qItem.replies" :key="reply.id">
                                        <div class="flex flex-col w-full gap-4">
                                            <div class="flex flex-row items-center gap-3">
                                                <img :src="avatarUrl('Admin')" class="w-8 h-8 rounded-full" alt="Avatar">
                                                
                                                <div class="flex flex-col gap-1">
                                                    <span class="text-sm font-semibold">Admin</span>
                                                    <span class="text-xs font-normal">{{ moment(reply.created_at).fromNow() }}</span>
                                                </div>
                                            </div>

                                            <img :src="reply.photo" class="w-40" alt="image" v-if="reply.photo">

                                            <span class="text-sm font-light leading-relaxed" v-html="sanitizedDesc(reply.content)">
                                            </span>
                                        </div>
                                    </div>
                                    
                                    <template #header>
                                        <div class="flex flex-col w-full gap-4">
                                            <div class="flex flex-row items-center gap-2">
                                                <img :src="qItem?.startup?.photo || avatarUrl(qItem.startup.name)" class="w-8 h-8 rounded-full" alt="Avatar">
                                                
                                                <span class="text-sm font-semibold">{{ qItem.startup.name }} · <span
                                                        class="text-xs font-normal">{{ moment(qItem.created_at).fromNow() }}</span></span>
                                            </div>
                                            <span class="text-sm font-light leading-relaxed">
                                                {{ qItem.content }}
                                            </span>
                                            <span class="text-xs font-medium text-light" v-if="qItem?.replies?.length > 0">Show Reply</span>
                                        </div>
                                    </template>
                                </a-collapse-panel>
                            </a-collapse>
                        </div>
                    </a-tab-pane>
                    <a-tab-pane :key="3" tab="Notes">
                        <div class="flex flex-col items-center w-full gap-3">
                            <div class="w-full p-2 border">
                                <a-textarea class="resize-none" 
                                    :bordered="false" 
                                    :rows="4"
                                    placeholder="Input your note" 
                                    v-model:value="formNote.notes"
                                    :maxlength="255"
                                    show-count
                                >
                                </a-textarea>

                                <a-divider class="my-2"></a-divider>
                                
                                <div class="flex flex-col items-end">
                                    <a-button class="w-fit" type="primary" @click="addNote">Save</a-button>
                                </div>
                            </div>
                            <div v-if="notes?.length > 0" class="w-full">
                                <div v-for="item in notes" :key="item" class="flex flex-col w-full gap-4 pt-4 pb-6 border-b">
                                    <p class="leading-relaxed text-md">
                                        {{ item.notes }}
                                    </p>           
                                    <span class="text-sm font-light"> -- {{ moment(item.created_at).fromNow() }}</span>
                                </div>
                            </div>
                            <a-empty v-else class="gap-3 flex items-center justify-center flex-col h-[20rem] w-full">
                                <template #description>
                                    <span class="text-sm text-gray-500">
                                        You don't have any note yet
                                    </span>
                                </template>
                            </a-empty>
                        </div>
                    </a-tab-pane>
                    <a-tab-pane :key="4" tab="Certificate">
                        <div class="flex flex-col items-center w-full gap-8">
                            <div class="flex flex-col w-full gap-3 md:gap-5">
                                <span class="text-base font-semibold md:text-lg text-light">Here's Your Certificates</span>
                                <div class="flex flex-col justify-between w-full gap-3 md:items-center md:flex-row">
                                    <div class="flex flex-row items-center gap-2 text-gray-700">
                                        <!-- <IconCalendarStats size="18" stroke-width="1.4" />
                                        <span class="text-[.8rem]">Issued On 08/2024</span> -->
                                    </div>
                                    <div class="grid flex-row w-full gap-3 md:grid-cols-2 lg:flex md:w-fit" v-if="learningProgress.percentage == 100">
                                        <a-button @click="downloadCertificate" size="small"
                                            class="flex flex-row items-center justify-center gap-2 p-5 md:p-3 text-primary">
                                            Download Certificate
                                            <IconDownload :size="16" :stroke-width="1.8" />
                                        </a-button>
                                        
                                        <a-dropdown>
                                            <template #overlay>
                                                <a-menu >
                                                    <share-network
                                                        :network="socmed.network"
                                                        :title="courseDetail.title"
                                                        v-slot="{ share }"
                                                        :url="shareUrl"
                                                        :description="sanitizedDesc(courseDetail.desc)"
                                                        :media="courseDetail.photo"
                                                        :key="socmed.name" 
                                                        v-for="socmed in socmeds"
                                                    >
                                                        <a-menu-item :key="socmed.name" @click="share">
                                                            <div class="flex flex-row items-center gap-1">
                                                                <component :is="socmed.icon" class="text-primary" />
                                                                {{ socmed.name }}
                                                            </div>
                                                        </a-menu-item>
                                                    </share-network>
                                                </a-menu>
                                            </template>

                                            <a-button size="small" class="flex flex-row items-center justify-center gap-2 p-5 md:p-3 text-primary">
                                                Share Your Certificate
                                                <IconShare :size="16" :stroke-width="1.8" />
                                            </a-button>
                                        </a-dropdown>

                                        <!-- <a-dropdown>
                                            <template #overlay>
                                                <a-menu @click="shareSocialMedia">
                                                    <a-menu-item key="LinkedIn">
                                                        <div class="flex flex-row items-center gap-1">
                                                            <IconBrandLinkedin class="text-primary " />
                                                            LinkedIn
                                                        </div>
                                                    </a-menu-item>
                                                    <a-menu-item key="Facebook">
                                                        <div class="flex flex-row items-center gap-1">
                                                            <IconBrandFacebook class="text-primary " />
                                                            Facebook
                                                        </div>
                                                    </a-menu-item>
                                                    <a-menu-item key="WhatsApp">
                                                        <div class="flex flex-row items-center gap-1">
                                                            <IconBrandWhatsapp class="text-primary " />
                                                            WhatsApp
                                                        </div>
                                                    </a-menu-item>
                                                    <a-menu-item key="Twitter">
                                                        <div class="flex flex-row items-center gap-1">
                                                            <IconBrandTwitter class="text-primary " />
                                                            Twitter
                                                        </div>
                                                    </a-menu-item>
                                                </a-menu>
                                            </template>

                                            <a-button size="small" class="flex flex-row items-center justify-center gap-2 p-5 md:p-3 text-primary">
                                                Share Your Certificate
                                                <IconShare :size="16" :stroke-width="1.8" />
                                            </a-button>
                                        </a-dropdown> -->
                                    </div>
                                </div>
                            </div>
                            <div class="w-full p-3 overflow-y-auto border">
                                <img :src="certificate" alt="" v-if="learningProgress?.percentage == 100 && !certifLoading">
                                <h2 class="text-center" v-else-if="learningProgress?.percentage == 100 && certifLoading">Please wait a moment, we are currently processing your certificate....</h2>
                                <h2 class="text-center" v-else>Complete the course or wait for our assessment to receive your certificate</h2>
                            </div>
                        </div>
                    </a-tab-pane>
                </a-tabs>
            </div>
        </div>
        <div class="col-span-4 xl:col-span-3 h-[90vh] hidden lg:inline overflow-y-auto">
            <div class="flex flex-col w-full min-h-full border-x-2">
                <div class="h-[4rem] border-b-2 w-full flex flex-row justify-between items-center px-4">
                    <span class="text-base font-semibold">Course content</span>
                </div>

                <a-collapse v-model:activeKey="sectionKey" expandIconPosition="end"
                    style="border-bottom: 2px solid #e6e7eb; border-radius: 0;" ghost
                    v-for="(cItem, index) in progressContent" v-if="progressContent?.length > 0" :key="index">
                    <a-collapse-panel :key="index">
                        <div class="flex flex-col w-full">
                            <div v-for="(lItem, lIndex) in cItem.sub_section" :key="lIndex"
                                :class="[
                                    'w-full flex flex-row cursor-pointer py-3 px-4 items-center justify-between',
                                    {
                                        'bg-[#3e8b174D]': isActiveLecture(index, lIndex),
                                        'hover:bg-[#3e8b171A]': !isActiveLecture(index, lIndex)
                                    }
                                ]">
                                <div class="grid items-center justify-between w-full grid-cols-12 gap-4" @click="isPrevCompleted(index, lIndex) || isAbleToNext(lItem.completed) || (index == 0 && lIndex == 0) ? onClickLecture(index, lIndex) : '' ">
                                    <!-- <a-checkbox></a-checkbox> -->
                                    <div class="flex flex-col col-span-10 gap-2">
                                        <span class="text-sm break-words">{{ lIndex + 1 }}. {{ lItem.title
                                        }}</span>
                                        <div
                                            :class="['flex flex-row gap-1 items-center', lIndex === 0 && index === 0 ? 'text-black' : 'text-gray-600']">
                                            <IconDeviceTv v-if="lItem.type === 'Video'" :size="18" stroke-width="1.5" />
                                            <IconFile v-else :size="18" stroke-width="1.5" />
                                            <span class="text-xs">{{  lItem.type == 'Video' ? lItem.duration+'min' : lItem.type }}</span>
                                        </div>
                                    </div>

                                    <IconCircleCheckFilled class="col-span-2 text-primary justify-self-end" v-if="lItem.completed == 1 || (isEnded && nowCourse.lIndex == lIndex && nowCourse.index == index && (lItem.type == 'Video' || (lItem.type == 'Quiz' && isQuizPassed)))" />
                                    <IconReport class="col-span-2 text-yellow-600 justify-self-end" v-else-if="lItem.completed == 2 || (isEnded && nowCourse.lIndex == lIndex && nowCourse.index == index && isQuizPassed && ['Essay', 'File'].includes(lItem.type))" />
                                    <IconCircleXFilled class="col-span-2 text-red-700 justify-self-end" v-else-if="lItem.completed == 3" />
                                </div>
                            </div>

                        </div>
                        <template #header>
                            <div class="flex flex-col gap-1">
                                <span class="text-base font-semibold">{{ cItem.title
                                }}</span>
                                <span class="text-xs text-gray-600">{{ cItem.progress }} / {{ cItem?.sub_section?.length }}</span>
                            </div>
                        </template>
                    </a-collapse-panel>
                    <template #expandIcon="{ isActive }">
                        <IconChevronLeft :size="15" stroke-width="2.5" v-if="isActive" />
                        <IconChevronDown :size="15" stroke-width="2.5" v-else />
                    </template>
                </a-collapse>

                <div class="w-full" v-else>
                    <a-empty :image="Empty.PRESENTED_IMAGE_SIMPLE" class="mt-20" :class="{ 'hidden': isHiddenEmptyCourseContent }">
                        <template #description>
                            <span class="text-sm text-gray-500">
                                Course content is empty
                            </span>
                        </template>
                    </a-empty>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { useBreakpoint } from '@/composables/useBreakpoints';
import { message, Empty } from 'ant-design-vue'
import moment from 'moment';

const { lgAndUp } = useBreakpoint();
</script>

<script>
import DummyCourse from '../../assets/Dummy/course.js'
import axios from '@/plugins/axios'
import moment from 'moment'
import {useRoute} from 'vue-router'
import DOMPurify from 'dompurify';
import { Modal } from 'ant-design-vue';


import {
    IconArrowRight,
    IconColorSwatch,
    IconClipboardText,
    IconCalendarStats,
    IconBrandYoutube,
    IconNotes,
    IconInfinity,
    IconBook,
    IconClockPlay,
    IconChartBar,
    IconSparkles,
    IconVideo,
    IconMessageQuestion,
    IconTerminal2,
    IconChevronDown,
    IconChevronLeft,
    IconDeviceTv,
    IconFile,
    IconPlayerPlayFilled,
    IconPlayerPauseFilled,
    IconVolume2,
    IconVolumeOff,
    IconMaximize,
    IconMinimize,
    IconUsersGroup,
    IconPencilPlus,
    IconDownload,
    IconShare,
    IconCircleCheckFilled,
    IconBrandLinkedin,
    IconBrandFacebook,
    IconBrandWhatsapp,
    IconBrandTwitter,
    IconReload,
    IconReport,
    IconCircleXFilled,
    IconListDetails,
} from '@tabler/icons-vue';

export default {
    name: 'ProducLearning',
    components: {
        IconArrowRight,
        IconColorSwatch,
        IconClipboardText,
        IconCalendarStats,
        IconBrandYoutube,
        IconNotes,
        IconInfinity,
        IconBook,
        IconClockPlay,
        IconChartBar,
        IconSparkles,
        IconVideo,
        IconMessageQuestion,
        IconTerminal2,
        IconChevronDown,
        IconChevronLeft,
        IconDeviceTv,
        IconFile,
        IconPlayerPlayFilled,
        IconPlayerPauseFilled,
        IconVolume2,
        IconVolumeOff,
        IconMaximize,
        IconMinimize,
        IconUsersGroup,
        IconPencilPlus,
        IconDownload,
        IconShare,
        IconBrandLinkedin,
        IconBrandFacebook,
        IconBrandWhatsapp,
        IconBrandTwitter,
        IconReload,
    },
    data() {
        return {
            route: useRoute(),
            course: null,
            courseDetail: null,
            courseInfo: null,
            courseContentOpen: 0,
            courseUrl: '',
            certificate: null,
            certifLoading: false,
            isQuizPassed: false,
            isExpanded: false,
            sectionKey: [],
            isPlaying: false,
            isMuted: false,
            isFullscreen: false,
            isEnded: false,
            isHiddenEmptyVideo: true,
            isHiddenEmptyCourseContent: true,
            nextCourse:{
                index: null,
                lIndex: null
            },
            nowCourse:{
                index: null,
                lIndex: null
            },
            currentTime: 0,
            duration: 0,
            formReview: {
                star: 0,
                review: ''
            },
            formNote: {
                notes: '',
            },
            formQnas: {
                content: '',
            },
            learningProgress: {
                total_sub_section: 0,
                total_my_progress: 0,
                percentage: 0
            },
            socmeds: [
                {
                    network: 'linkedin',
                    name: 'LinkedIn',
                    icon: 'IconBrandLinkedin',
                },
                {
                    network: 'facebook',
                    name: 'Facebook',
                    icon: 'IconBrandFacebook',
                },
                {
                    network: 'twitter',
                    name: 'Twitter',
                    icon: 'IconBrandTwitter',
                },
                {
                    network: 'whatsapp',
                    name: 'WhatsApp',
                    icon: 'IconBrandWhatsapp',
                },
            ],
            myReview: null,
            notes: [],
            qnas: [],
            progressBarWidth: 0,
            progressContent: [],
            tab: 0,
            panel: 'Video',
            panelStatusCompleted: 0,
            quiz: [],
            videoUrl: null,
            reviews: [],
            activeLecture: null,
            openQna: 0,
            isUserNotComplete: false,
            currentSubSectionContent: null,
            showHelperOverlay: false,
            shouldShowHelper: false,
            replayingVideo: false,

        }
    },
    watch: {
        async isEnded(newValue) {
            if (newValue) {
                this.learningProgress = await this.fetchLearningProgress();
                this.progressContent = await this.fetchProgressContent();
            }

            if ((this.currentSubSectionContent?.helper_link || this.currentSubSectionContent?.downloadable_link) && !this.replayingVideo) {
                this.shouldShowHelper = true;
            }
        },

        // isQuizzpassed
        async tab(newValue) {
            if (newValue == 4) {
                this.certificate = await this.fetchCertificate();

                this.isUserNotComplete = this.learningProgress.percentage == 100 && !this.certificate; 
            }
        },

        isUserNotComplete(newValue) {
            if (newValue) {

            console.log(newValue, 'newValue');
                Modal.warning({
                    title: 'Your settings are incomplete',
                    content: "Please complete them to access your certificate.",
                    okText: 'See Dashboard',
                    onOk: () => {
                        this.goTo('/Internal/Core')
                    },
                    centered: true
                });
            }
        }
    },
    async mounted() {
        const [courseDetail, courseInfo] = await Promise.all([
            this.fetchCourseDetail(),
            this.fetchCourseInfo(),
        ]);

        this.courseDetail = courseDetail;
        this.courseInfo = courseInfo;

        this.loadAdditionalData();

        await this.loadYouTubeAPI(); 
        const index = parseInt(this?.route?.query?.index) || 0;
        const lIndex = parseInt(this?.route?.query?.lIndex) || 0;

        this.onClickLecture(index, lIndex);

        this.$nextTick(() => {
            if (this.$refs.video) {
                this.$refs.video.addEventListener('loadedmetadata', this.initializeVideo);
            }
        });
    },
    computed: {
        isActiveLecture() {
            return (index, lIndex) => {
                const checkActive = this.activeLecture === index + ' ' + lIndex
                if (checkActive) {
                    this.nowCourse.index = index
                    this.nowCourse.lIndex = lIndex
                }

                return checkActive;
            };
        },
        avatarUrl() {
            return (name) => {
                const initials = this.getInitials(name);
    
                return `https://ui-avatars.com/api/?name=${initials}&size=128&background=random`;
            };
        },
        shareUrl() {
            return `${window.location.origin}/Course/Detail/${this.route.params.CourseID}`;
        },
    },

    methods: {
        async loadAdditionalData() {
            try {
                const [progressContent, learningProgress, reviews, notes, qnas, certificate] = await Promise.all([
                    this.fetchProgressContent(),
                    this.fetchLearningProgress(),
                    this.fetchReviews(),
                    this.fetchNotes(),
                    this.fetchQnas(),
                    // this.fetchCertificate()
                ]);

                this.progressContent = progressContent;
                this.learningProgress = learningProgress;
                this.reviews = reviews;
                this.notes = notes;
                this.qnas = qnas;
                // this.certificate = certificate;
            } catch (error) {
                console.error("Error fetching additional data:", error);
            }
        },
        shareSocialMedia({ key }) {
            let shareUrl = '';
            this.courseUrl = `${window.location.origin}/Course/Detail/${this.route.params.CourseID}`;

            switch (key) {
                case 'LinkedIn':
                shareUrl = `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(this.courseUrl)}`;
                break;
                case 'Facebook':
                shareUrl = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(this.courseUrl)}`;
                break;
                case 'WhatsApp':
                shareUrl = `https://api.whatsapp.com/send?text=${encodeURIComponent(this.courseUrl)}`;
                break;
                case 'Twitter':
                shareUrl = `https://twitter.com/intent/tweet?url=${encodeURIComponent(this.courseUrl)}`;
                break;
                default:
                return;
            }

            window.open(shareUrl, '_blank');
        },
        async loadYouTubeAPI() {
            return new Promise((resolve) => {
                if (window.YT && window.YT.Player) {
                    resolve();
                } else {
                    const tag = document.createElement("script");
                    tag.src = "https://www.youtube.com/iframe_api";
                    const firstScriptTag = document.getElementsByTagName("script")[0];
                    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

                    window.onYouTubeIframeAPIReady = resolve;
                }
            });
        },
        initializeYouTubePlayer() {
            if (this.ytPlayer) {
                this.ytPlayer.destroy();
                this.ytPlayer = null;
            }
            
            this.ytPlayer = new YT.Player("player", {
                height: "100%",
                width: "100%",
                videoId: this.extractVideoId(this.videoUrl),
                playerVars: {
                    playsinline: 1,
                },
                events: {
                    onStateChange: this.onPlayerStateChange,
                },
            });
        },
        async onPlayerStateChange(event) {
            if (event.data === YT.PlayerState.ENDED) {
                await this.setChecked(this.progressContent[this.nowCourse.index]?.sub_section[this.nowCourse.lIndex].id)
                this.isEnded = true;
                this.replayingVideo = false;
            } 
        },
        handleAnswerSubmitted() {
            this.isEnded = true;
        },
        extractVideoId(url) {
            const regex = /(?:https?:\/\/)?(?:www\.)?(?:youtube\.com\/(?:embed\/|watch\?v=)|youtu\.be\/)([a-zA-Z0-9_-]{11})/;
            const match = url.match(regex);

            return match ? match[1] : null;
        },
        isNextAvailable(index, lIndex){
            return index != null && lIndex != null;
        },
        async fetchCourseDetail() {
            try {
                const response = await axios.get(`/course/${this.route.params.CourseID}`)
                return response?.data?.courses
            } catch (error) {
                console.error('Error fetching course detail:', error)
            }
        },
        async fetchCourseInfo() {
            try {
                const response = await axios.get(`/course/${this.route.params.CourseID}/detail`)
                return response?.data
            } catch (error) {
                console.error('Error fetching course info:', error)
            }
        },
        async setChecked(id) {
            try {
                await axios.post(`/subsection/${id}/submit-answer`)
            } catch (error) {
                console.error('Error set checked:', error)
            }
        },
        async fetchLearningProgress() {
            try {
                const response = await axios.get(`/course/${this.courseDetail.id}/progress`)
                return response?.data
            } catch (error) {
                console.error('Error fetching learning progress:', error)
            }
        },
        async fetchProgressContent() {
            try {
                const response = await axios.get(`/course/${this.courseDetail.id}/progress-content`)
                this.sectionKey = Object.keys(response?.data)
                
                if (response?.data?.length == 0) {
                    this.isHiddenEmptyCourseContent = false
                }

                return response?.data
            } catch (error) {
                if (error.response.status == 401) {
                    window.location.href = '/SignIn'
                }

                console.error('Error fetching progress content:', error)
            }
        },
        async fetchSubSectionContent(subSectionContentId) {
            try {
                const response = await axios.get(`/subsection/${subSectionContentId}/subsection-content`)

                return response?.data
            } catch (error) {
                let redirect = '/Course/Discovery'

                if (this.courseDetail?.program_id) {
                    redirect = '/Program/Discovery'
                }

                if (error.response.status == 423) {
                    redirect = '/Program/Detail/'+this.courseDetail?.program_id
                }
                
                if (error.response.status == 403) {
                    redirect = '/Course/Learning/'+this.route.params.CourseID
                }
                
                window.location.href = redirect

                console.error('Error fetching sub section content:', error)
            }
        },
        async fetchReviews() {
            try {
                const response = await axios.get(`/course/${this.route.params.CourseID}/reviews`)

                this.myReview = response?.data?.my_review

                return response?.data?.data
            } catch (error) {
                console.error('Error fetching reviews:', error)
            }
        },
        async addReview() {
            try {
                const formData = new FormData();
                formData.append("star", this.formReview.star);
                formData.append("review", this.formReview.review);
                
                await axios.post(`/review/${this.courseDetail.id}`, formData)

                message.success('Success add review');

                this.reviews = await this.fetchReviews()
            } catch (error) {
                message.error(error?.response?.data?.message ?? 'An error occurred. Please try again later.')
                console.error('Error add review:', error)
            }
        },
        async fetchNotes() {
            try {
                const response = await axios.get(`/course/${this.courseDetail.id}/notes`)
                return response?.data?.data
            } catch (error) {
                console.error('Error fetching notes:', error)
            }
        },
        async addNote() {
            try {
                const formData = new FormData();
                formData.append("notes", this.formNote.notes);
                
                await axios.post(`/notes/${this.courseDetail.id}`, formData)

                message.success('Success add note');

                this.notes = await this.fetchNotes()

                this.formNote =  {
                    notes: '',
                };
            } catch (error) {
                message.error(error?.response?.data?.message ?? 'An error occurred. Please try again later.')
                console.error('Error add note:', error)
            }
        },
        async fetchQnas() {
            try {
                const response = await axios.get(`course/${this.courseDetail.id}/q-a`)
                return response?.data?.data
            } catch (error) {
                console.error('Error fetching Q & A:', error)
            }
        },
        async addQnas() {
            try {
                const formData = new FormData();
                formData.append("content", this.formQnas.content);
                
                await axios.post(`/q-a/${this.courseDetail.id}`, formData)

                message.success('Success add question');

                this.qnas = await this.fetchQnas()

                this.formQnas =  {
                    content: '',
                };
            } catch (error) {
                message.error(error?.response?.data?.message ?? 'An error occurred. Please try again later.')
                console.error('Error add question:', error)
            }
        },
        async fetchCertificate() {
            this.certifLoading = true;
            try {
                const response = await axios.get(`/course/${this.courseDetail.id}/certificate/`, {
                    responseType: 'blob',
                });
                
                this.certifLoading = false;
                return URL.createObjectURL(response.data);
            } catch (error) {
            }

            this.certifLoading = false;

        },
        getInitials(name) {
            const defaultInitial = "P+P"
            if (!name) return defaultInitial;

            const parts = name.split(' ');
            const initials = parts.map(part => part.charAt(0).toUpperCase()).join('+');
            return initials || defaultInitial;
        },
        goTo(url) {
            window.location.href = url
        },
        downloadCertificate() {
            const a = document.createElement('a');
            a.href = this.certificate;
            a.download = 'certificate.png';
            document.body.appendChild(a);
            a.click();

            document.body.removeChild(a);

            URL.revokeObjectURL(this.certificate);
        },
        initializeVideo() {
            this.duration = this.$refs.video.duration;
        },
        togglePlayPause() {
            const video = this.$refs.video;
            if (video.paused) {
                video.play();
                this.isPlaying = true;
            } else {
                video.pause();
                this.isPlaying = false;
            }
        },
        updateProgress() {
            const video = this.$refs.video;
            this.currentTime = video.currentTime;
            this.progressBarWidth = (video.currentTime / video.duration) * 100;
        },
        minuteToHour(minute) {
            const hour = Math.floor(minute / 60);
            const min = minute % 60;

            if (hour > 0) {
                if(min == 0){
                    return `${hour}h`;
                }

                return `${hour}h ${min}m`;
            }

            return `${min}m`;
        },
        formatTime(time) {
            const minutes = Math.floor(time / 60);
            const seconds = Math.floor(time % 60).toString().padStart(2, '0');
            return `${minutes}:${seconds}`;
        },
        sanitizedDesc (desc) {
            return DOMPurify.sanitize(desc);
        },
        toggleReadMore() {
            this.isExpanded = !this.isExpanded;
        },
        toggleMute() {
            const video = this.$refs.video;
            video.muted = !video.muted;
            this.isMuted = video.muted;
        },
        toggleFullscreen() {
            const videoContainer = this.$refs.video.parentNode;
            if (!document.fullscreenElement) {
                videoContainer.requestFullscreen();
                this.isFullscreen = true;
            } else {
                document.exitFullscreen();
                this.isFullscreen = false;
            }
        },
        handleCloseHelper() {
            this.replayingVideo = true;
            this.shouldShowHelper = false;
        },
        replayVideo() {
            this.shouldShowHelper = false;
            this.replayingVideo = true;
            this.$nextTick(() => {
                if (this.ytPlayer) {
                    this.ytPlayer.seekTo(0);
                    this.ytPlayer.playVideo();
                } else {
                    this.initializeYouTubePlayer();
                }
            });
        },
        showResourceDuringReplay() {
            this.replayingVideo = false;
            this.shouldShowHelper = true;
            if (this.ytPlayer && typeof this.ytPlayer.pauseVideo === 'function') {
                this.ytPlayer.pauseVideo();
            }
        },
        async nextSectionCourse(index, lIndex) {
            // await this.setChecked(this.progressContent[this.nowCourse.index]?.sub_section[this.nowCourse.lIndex].id)

            if (!this.isNextAvailable(index, lIndex)) {
                this.tab = 4;
            }else{
                await this.onClickLecture(index, lIndex)
            }

        },
        async onClickLecture(index, lIndex) {
            this.$router.replace({
                query: {
                    ...this.$route.query,
                    index: index,
                    lIndex: lIndex
                }
            });

            this.learningProgress = await this.fetchLearningProgress()
            this.progressContent = await this.fetchProgressContent()
            const subSection = await this.fetchSubSectionContent(this.progressContent[index]?.sub_section[lIndex].id)
            this.quiz = [];
            this.panel = 'Video';
            this.panelStatusCompleted = this.progressContent[index]?.sub_section[lIndex]?.completed

            this.isEnded = [1, 2, 3].includes(this.panelStatusCompleted);
            
            // Store the full content for helper_link reference
            this.currentSubSectionContent = subSection;
            
            // Show helper overlay if helper_link or downloadable_link exists, otherwise hide it
            this.showHelperOverlay = (subSection?.helper_link || subSection?.downloadable_link) ? true : false;
            this.shouldShowHelper = this.showHelperOverlay && this.isEnded;
            this.replayingVideo = false;
            
            if (subSection?.length >= 0) {
                this.quiz = subSection
                this.panel = 'Quiz';

                const subSectionType = subSection[0]?.sub_section?.type;
                
                if (subSectionType) {
                    this.panel = subSectionType;
                }
            }else{
                this.$nextTick(() => {
                    this.videoUrl = subSection?.content

                    if (this.videoUrl) {
                        this.initializeYouTubePlayer();
                    }else{
                        this.isHiddenEmptyVideo = false;
                    }
                });
            }
            
            this.activeLecture = index + ' ' + lIndex;
            
            this.nextCourse = {
                index: null,
                lIndex: null
            }

            if(this.progressContent[index]?.sub_section[lIndex + 1]?.id){
                this.nextCourse = {
                    index: index,
                    lIndex: lIndex + 1
                };
            }else if (this.progressContent[index + 1]?.sub_section[0]?.id){
                this.nextCourse = {
                    index: index + 1,
                    lIndex: 0
                };
            }
        },
        getLectureOrder(sIndex, lIndex) {
            let order = 0;
            for (let i = 0; i < sIndex; i++) {
                order += this?.course?.section[i].lecturer?.length;
            }
            return order + lIndex + 1;
        },
        isPrevCompleted(index, lIndex) {
            let prevCourse = {
                index: null,
                lIndex: null
            };
            
            if (lIndex > 0 && this.progressContent[index]?.sub_section[lIndex - 1]?.id) {
                prevCourse = {
                    index: index,
                    lIndex: lIndex - 1
                };
            } else if (index > 0) {
                const prevSubSection = this.progressContent[index - 1]?.sub_section;
                if (prevSubSection && prevSubSection?.length > 0) {
                    prevCourse = {
                        index: index - 1,
                        lIndex: prevSubSection?.length - 1
                    };
                }
            }

            return this.isAbleToNext(this.progressContent[prevCourse.index]?.sub_section[prevCourse.lIndex]?.completed)
        },
        isAbleToNext(value){
            return [1,2].includes(value)
        },
    }
    
}
</script>
